// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-family: "Fivo Sans Medium", sans-serif;
  position: sticky;
  top: -1.25em;
  background: white;
  z-index: 100;
}
.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 400px;
  max-width: 80%;
  max-height: 80vh;
  overflow-y: auto;
}

.modal-content label {
  display: block;
  margin-bottom: 10px;
  font-family: "Fivo Sans Regular", sans-serif;
  text-align: left;
}
.modal-input {
  width: 100%;
  padding: 0.5em;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 0.625em;
  box-sizing: border-box;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  position: sticky;
  bottom: -1.25em;
  background: white;
  padding-top: 0.625em;
  z-index: 10;
}

.modal-actions button {
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  border: none;
  cursor: pointer;
}

.modal-actions button:hover {
  background-color: #218838;
}

.modal-actions button:nth-child(2) {
  background-color: #dc3545;
}

.modal-actions button:nth-child(2):hover {
  background-color: #c82333;
}
`, "",{"version":3,"sources":["webpack://./src/components/YourCreations/EditModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n.modal-header {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  font-family: \"Fivo Sans Medium\", sans-serif;\n  position: sticky;\n  top: -1.25em;\n  background: white;\n  z-index: 100;\n}\n.modal-content {\n  background: white;\n  padding: 20px;\n  border-radius: 5px;\n  width: 400px;\n  max-width: 80%;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.modal-content label {\n  display: block;\n  margin-bottom: 10px;\n  font-family: \"Fivo Sans Regular\", sans-serif;\n  text-align: left;\n}\n.modal-input {\n  width: 100%;\n  padding: 0.5em;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  margin-bottom: 0.625em;\n  box-sizing: border-box;\n}\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n  position: sticky;\n  bottom: -1.25em;\n  background: white;\n  padding-top: 0.625em;\n  z-index: 10;\n}\n\n.modal-actions button {\n  padding: 10px 20px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\n.modal-actions button:hover {\n  background-color: #218838;\n}\n\n.modal-actions button:nth-child(2) {\n  background-color: #dc3545;\n}\n\n.modal-actions button:nth-child(2):hover {\n  background-color: #c82333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
